import React, { InputHTMLAttributes, forwardRef } from 'react';
import './FormInput.css';

interface FormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  icon?: React.ReactNode;
  fullWidth?: boolean;
}

const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  ({ label, error, helperText, icon, fullWidth = false, className, ...props }, ref) => {
    const inputClasses = [
      'form-input',
      fullWidth && 'form-input--full-width',
      error && 'form-input--error',
      icon && 'form-input--with-icon',
      className
    ].filter(Boolean).join(' ');

    return (
      <div className="form-input-wrapper">
        {label && (
          <label className="form-input-label" htmlFor={props.id}>
            {label}
          </label>
        )}
        
        <div className="form-input-container">
          {icon && (
            <div className="form-input-icon">
              {icon}
            </div>
          )}
          
          <input
            ref={ref}
            className={inputClasses}
            {...props}
          />
        </div>
        
        {(error || helperText) && (
          <div className={`form-input-help ${error ? 'form-input-help--error' : ''}`}>
            {error || helperText}
          </div>
        )}
      </div>
    );
  }
);

FormInput.displayName = 'FormInput';

export default FormInput; 